import { HiX } from 'react-icons/hi';

import Overlay from '@core/blocks/edu-match/components/Overlay';

import styles from './Popup.module.css';
import type { TPopup } from './types';

const Popup: TPopup = ({ show, onClose, children, closeOnOverlayClick = false }) => {
  const overlayClickHandler = closeOnOverlayClick ? onClose : undefined;

  if (!show) return null;

  return (
    <div className={styles.popupContainer}>
      <Overlay clickHandler={overlayClickHandler} />
      <div className={styles.popup}>
        {onClose && (
          <button data-testid="popup-close-btn" type="button" className={styles.closeBtn} onClick={onClose}>
            <HiX size="1.5rem" />
          </button>
        )}
        {children}
      </div>
    </div>
  );
};

export default Popup;
